'use strict';
import Swiper from 'swiper';
export default class Slider {
  constructor() {
    this.name = 'slider';

    const dekstopSlider = document.getElementsByClassName('cost-swiper-container');
    const mobileSlider = document.getElementsByClassName('cost-swiper-container-mobile');
    const menu = document.getElementsByClassName('slider-menu__step');
    const illustrationSteps = document.getElementsByClassName('swiper-illustration__step');
    
    const prevArrow = document.getElementsByClassName('swiper-button-prev')[0];
    const nextArrow = document.getElementsByClassName('swiper-button-next')[0];
    prevArrow.classList.add('first-slide');

    // Check slider is defined
    if (dekstopSlider.length > 0) {
      const mySwiper2Element =  document.getElementsByClassName('cost-swiper-container')[0];
      var mySwiper2 = new Swiper ('.cost-swiper-container', {

        loop: false,
        pagination: {
          el: '.swiper-pagination',
        },
        effect: 'fade',  
        fadeEffect: {
          crossFade: true
        },
    
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
  
      mySwiper2.on('slideChange', function() {
        const index = mySwiper2.realIndex+1;
        mySwiper2Element.classList.add(`js-slide-${index}`);
        removeActiveFromElements(menu);
        addActiveClass(document.getElementById(`slide-${index}`));

        removeActiveFromElements(illustrationSteps);
        addActiveClass(document.getElementById(`illustration__step-${index}`));

        if(index != 1) {
          prevArrow.classList.remove('first-slide');
        }

        if (index != 5) {
          nextArrow.classList.remove('last-slide');
        }

      });

      mySwiper2.on('reachBeginning', function() {
        prevArrow.classList.add('first-slide');
      });

      mySwiper2.on('reachEnd', function() {
        nextArrow.classList.add('last-slide');
      });
    }

    if (mobileSlider.length > 0) {
      var mySwiper3 = new Swiper ('.cost-swiper-container-mobile', {
        // Optional parameters
        loop: true,
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },
        spaceBetween: 8,
    
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }

    // Menu

    function removeActiveFromElements (elements) {
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.remove('active');
      }
    }

    function addActiveClass (element) {
      element.classList.add('active');
    }

    function handleMenuClick (e) {
      const index = this.dataset.slide;
      console.log(index);
      mySwiper2.slideTo(index);
      removeActiveFromElements(menu);
      addActiveClass(this);
    }
    
    for (let i = 0; i < menu.length; i++) {
      menu[i].addEventListener('click', handleMenuClick);
    }

  };
}
